import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
const LOGO = 'https://cdn.magicpatterns.com/uploads/kMr1HJrWNP6q49tbTrJRRT/efe0d197-a05a-4593-b2af-113191e9c14c-removebg-preview.png';
interface NavLink {
  label: string;
  target: string;
}
interface HeaderProps {
  links: NavLink[];
  enrollTarget?: string;
}
export const Header: React.FC<HeaderProps> = ({
  links,
  enrollTarget = 'pricing'
}) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const scrollTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-navy-dark/95 backdrop-blur-md border-b border-gold/20' : 'bg-transparent'}`} data-id="element-101">
      <div className="container mx-auto px-6" data-id="element-102">
        <div className="flex items-center justify-between h-20" data-id="element-103">
          {/* Logo */}
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="flex items-center shrink-0" aria-label="NLP Academy" data-id="element-104">
            <img src={LOGO} alt="NLP Academy" className="h-12 w-auto" data-id="element-105" />
          </button>
          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-106">
            {links.map(link => <button key={link.target} onClick={() => scrollTo(link.target)} className="font-display text-sm font-semibold tracking-wide uppercase text-textLight hover:text-gold transition-colors duration-200" data-id="element-107">
                {link.label}
              </button>)}
            <button onClick={() => scrollTo(enrollTarget)} className="inline-flex items-center justify-center px-6 py-3 font-display font-semibold tracking-wide text-sm uppercase bg-gold text-navy-dark hover:bg-white transition-all duration-300" data-id="element-108">
              Înscrie-te acum
            </button>
          </nav>
          {/* Mobile toggle */}
          <button onClick={() => setOpen(o => !o)} className="lg:hidden text-textLight p-2" aria-label="Meniu" data-id="element-109">
            {open ? <X className="w-6 h-6" data-id="element-110" /> : <Menu className="w-6 h-6" data-id="element-111" />}
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      {open && <div className="lg:hidden bg-navy-dark/98 backdrop-blur-md border-t border-gold/20" data-id="element-112">
          <nav className="container mx-auto px-6 py-6 flex flex-col gap-4" data-id="element-113">
            {links.map(link => <button key={link.target} onClick={() => scrollTo(link.target)} className="font-display text-base font-semibold tracking-wide uppercase text-textLight hover:text-gold transition-colors text-left" data-id="element-114">
                {link.label}
              </button>)}
            <button onClick={() => scrollTo(enrollTarget)} className="mt-2 inline-flex items-center justify-center px-6 py-3 font-display font-semibold tracking-wide text-sm uppercase bg-gold text-navy-dark" data-id="element-115">
              Înscrie-te acum
            </button>
          </nav>
        </div>}
    </header>;
};